import { toast } from 'react-toastify';
import { UseMutationResult, UseQueryResult } from '@tanstack/react-query';
import { Form } from '@ui';
import {
  getDefaultSSchedulerRulesValues,
  sSchedulerSettingsRulesFormSchema,
} from '@lp/features/Scheduler/SchedulerSurgeonsSettings/config';
import { SchedulerSettingsSubmitRow } from '@lp/features/Scheduler/components';
import { SSchedulerSettingsRulesFormType } from '@lp/features/Scheduler/SchedulerSurgeonsSettings/types';
import { SSchedulerSettingsRulesForm } from '@lp/features/Scheduler/SchedulerSurgeonsSettings/components';
import { SResourceRulesSettings } from '@/api/apis/resources/schedule';
import { retrieveUnifiedError } from '@/api/utils';

type SSchedulerSettingsRulesTabProps = {
  scheduleBackPath: string;
  useSScheduleSettingsRulesQuery: () => UseQueryResult<SResourceRulesSettings, Error>;
  useSSetScheduleSettingsRulesMutation: () => UseMutationResult<SResourceRulesSettings, Error, SResourceRulesSettings>;
};

export const SSchedulerSettingsRulesTab = ({
  scheduleBackPath,
  useSScheduleSettingsRulesQuery,
  useSSetScheduleSettingsRulesMutation,
}: SSchedulerSettingsRulesTabProps) => {
  const { data: rulesData } = useSScheduleSettingsRulesQuery();
  const { mutateAsync, isPending } = useSSetScheduleSettingsRulesMutation();

  const handleSubmit = async (data: SSchedulerSettingsRulesFormType) => {
    try {
      await mutateAsync(data);
      toast.success(`Scheduler Rules updated successfully`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  if (!rulesData) return null;

  return (
    <Form<SSchedulerSettingsRulesFormType>
      defaultValues={getDefaultSSchedulerRulesValues(rulesData)}
      schema={sSchedulerSettingsRulesFormSchema}
      onSubmit={handleSubmit}
    >
      <SSchedulerSettingsRulesForm />
      <SchedulerSettingsSubmitRow backPath={scheduleBackPath} isLoading={isPending} />
    </Form>
  );
};
